/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useEffect } from 'react';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UITable from 'UIComponents/table/UITable';
import UIFlex from 'UIComponents/layout/UIFlex';
import UITableHoverCell from 'UIComponents/table/UITableHoverCell';
import UILink from 'UIComponents/link/UILink';
import UITruncateString from 'UIComponents/text/UITruncateString';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIAlert from 'UIComponents/alert/UIAlert';
import Routes from 'ContentUtils/Routes';
import LegacyEmailAlert from 'ContentComponents/cmv2/form/formAutomation/followupEmail/LegacyEmailAlert';
import FollowupEmailSelect from 'ContentComponents/cmv2/form/formAutomation/followupEmail/FollowupEmailSelect';
import FollowupEmailWorkflowButton from 'ContentComponents/cmv2/form/formAutomation/followupEmail/FollowupEmailWorkflowButton';
import EmailSelectedForFormAlert from 'ContentComponents/cmv2/form/formAutomation/followupEmail/EmailSelectedForFormAlert';
import { getEmail, getEmailFetchStatus } from 'ContentData/selectors/emails';
import * as EmailsActions from 'ContentData/actions/Emails';
import * as RequestStatuses from 'ContentUtils/constants/RequestStatus';
import text from 'I18n/utils/unescapedText';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.form.formWorkflowDependencies.followupEmailWorkflows.${key}`;
function mapStateToProps(state, props) {
  const {
    followupEmailId,
    followupEmailSelectedForForm
  } = props;
  let followupEmail;
  let emailFetchStatus;
  if (followupEmailId) {
    followupEmail = getEmail(state, {
      id: followupEmailId
    });
    emailFetchStatus = getEmailFetchStatus(state, {
      id: followupEmailId
    });
  } else if (followupEmailSelectedForForm) {
    const {
      emailId
    } = followupEmailSelectedForForm;
    followupEmail = emailId && getEmail(state, {
      id: emailId
    });
  }
  return {
    followupEmail,
    emailFetchStatus
  };
}
const mapDispatchToProps = {
  fetchFollowupEmail: EmailsActions.fetchEmail
};
const connector = connect(mapStateToProps, mapDispatchToProps);
const FollowupEmailTable = ({
  contentId,
  emailId,
  emailName,
  formGuid,
  hasAutomatedEmailEditorAccess,
  hasInlineEmailEditorAccess,
  hasWorkflowsAppAccess,
  isReadOnly,
  onChangeFollowupEmailEvent,
  onFollowupEmailIdChange,
  seleniumKey
}) => {
  const label = emailName || emailId;
  const emailLabel = hasAutomatedEmailEditorAccess ? /*#__PURE__*/_jsx(UILink, {
    external: true,
    href: Routes.editEmail(emailId),
    truncate: true,
    children: label
  }) : /*#__PURE__*/_jsx(UITruncateString, {
    children: label
  });
  const onRemoveFollowupEmail = () => {
    if (onChangeFollowupEmailEvent) {
      onChangeFollowupEmailEvent('form-followup-email-remove');
    }
    onFollowupEmailIdChange();
  };
  const actions = /*#__PURE__*/_jsxs(UIFlex, {
    children: [/*#__PURE__*/_jsx(FollowupEmailWorkflowButton, {
      contentId: contentId,
      followupEmailId: emailId,
      formGuid: formGuid,
      hasAutomatedEmailEditorAccess: hasAutomatedEmailEditorAccess,
      hasInlineEmailEditorAccess: hasInlineEmailEditorAccess,
      hasWorkflowsAppAccess: hasWorkflowsAppAccess,
      onChangeFollowupEmailEvent: onChangeFollowupEmailEvent,
      onFollowupEmailIdChange: onFollowupEmailIdChange,
      readOnly: isReadOnly
    }), /*#__PURE__*/_jsx(UIIconButton, {
      "aria-label": text(i18nKey('removeEmailTooltip')),
      "data-selenium": "form-followup-email-remove-button",
      disabled: isReadOnly,
      onClick: onRemoveFollowupEmail,
      size: "xs",
      tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('removeEmailTooltip')
      }),
      children: /*#__PURE__*/_jsx(UIIcon, {
        name: "remove"
      })
    })]
  });
  return /*#__PURE__*/_jsx(UITable, {
    "data-selenium": seleniumKey,
    responsiveWrapperClassName: "m-y-2",
    children: /*#__PURE__*/_jsx("tbody", {
      children: /*#__PURE__*/_jsx("tr", {
        children: /*#__PURE__*/_jsx(UITableHoverCell, {
          className: "p-all-4",
          hoverContent: actions,
          children: emailLabel
        })
      })
    })
  });
};
const FollowupEmail = ({
  contentId,
  clearLegacyFollowupEmail,
  emailFetchStatus,
  fetchFollowupEmail,
  followupEmail,
  followupEmailId,
  followupEmailSelectedForForm,
  formGuid,
  hasAutomatedEmailEditorAccess,
  hasInlineEmailEditorAccess,
  hasWorkflowsAppAccess,
  legacyFollowupEmailId,
  onChangeFollowupEmailEvent,
  onFollowupEmailIdChange,
  readOnly,
  scrollToFollowupEmail
}) => {
  useEffect(() => {
    if (followupEmailId) {
      fetchFollowupEmail(followupEmailId);
    }
    if (legacyFollowupEmailId) {
      fetchFollowupEmail(legacyFollowupEmailId);
    }
    const {
      emailId
    } = followupEmailSelectedForForm || {};
    if (emailId) {
      fetchFollowupEmail(emailId);
    }
  }, [fetchFollowupEmail, followupEmailId, legacyFollowupEmailId, followupEmailSelectedForForm]);
  let content;
  const {
    emailId: emailIdSelectedForForm
  } = followupEmailSelectedForForm || {};
  if (legacyFollowupEmailId) {
    content = /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(LegacyEmailAlert, {
        clearLegacyFollowupEmail: clearLegacyFollowupEmail,
        emailId: legacyFollowupEmailId,
        onChangeFollowupEmailEvent: onChangeFollowupEmailEvent,
        onFollowupEmailIdChange: onFollowupEmailIdChange
      }), /*#__PURE__*/_jsx(FollowupEmailSelect, {
        onChange: () => {},
        onCreateEmail: () => {},
        readOnly: true,
        showLegacyEmails: true,
        value: legacyFollowupEmailId
      })]
    });
  } else if ((followupEmailId || emailIdSelectedForForm) && !followupEmail && emailFetchStatus !== RequestStatuses.FAILED) {
    content = /*#__PURE__*/_jsx(UILoadingSpinner, {
      layout: "centered",
      className: "p-y-3"
    });
  } else if (emailIdSelectedForForm) {
    const {
      editModule,
      editSmartRule,
      inSameModule,
      formFieldPath
    } = followupEmailSelectedForForm || {};
    content = /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(EmailSelectedForFormAlert, {
        formFieldPath: formFieldPath,
        editModule: editModule,
        editSmartRule: editSmartRule,
        inSameModule: inSameModule,
        scrollToFollowupEmail: scrollToFollowupEmail
      }), /*#__PURE__*/_jsx(FollowupEmailTable, {
        contentId: contentId,
        emailId: emailIdSelectedForForm,
        emailName: followupEmail ? followupEmail.name : undefined,
        formGuid: formGuid,
        hasAutomatedEmailEditorAccess: hasAutomatedEmailEditorAccess,
        hasInlineEmailEditorAccess: hasInlineEmailEditorAccess,
        hasWorkflowsAppAccess: hasWorkflowsAppAccess,
        isReadOnly: true,
        onChangeFollowupEmailEvent: onChangeFollowupEmailEvent,
        onFollowupEmailIdChange: onFollowupEmailIdChange,
        seleniumKey: "form-followup-email"
      })]
    });
  } else if (followupEmailId) {
    const table = /*#__PURE__*/_jsx(FollowupEmailTable, {
      contentId: contentId,
      emailId: followupEmailId,
      emailName: followupEmail ? followupEmail.name : undefined,
      formGuid: formGuid,
      hasAutomatedEmailEditorAccess: hasAutomatedEmailEditorAccess,
      hasInlineEmailEditorAccess: hasInlineEmailEditorAccess,
      hasWorkflowsAppAccess: hasWorkflowsAppAccess,
      isReadOnly: readOnly,
      onChangeFollowupEmailEvent: onChangeFollowupEmailEvent,
      onFollowupEmailIdChange: onFollowupEmailIdChange,
      seleniumKey: "form-followup-email"
    });
    if (followupEmail && !followupEmail.isPublished) {
      content = /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(UIAlert, {
          titleText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('unpublishedEmailAlert.title')
          }),
          type: "danger",
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: i18nKey('unpublishedEmailAlert.message_jsx'),
            options: {
              href: Routes.editEmail(followupEmailId)
            },
            elements: {
              Link: UILink
            }
          })
        }), table]
      });
    } else if (!followupEmail && emailFetchStatus === RequestStatuses.FAILED) {
      content = /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(UIAlert, {
          titleText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('notFoundEmailAlert.title')
          }),
          type: "danger",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('notFoundEmailAlert.message')
          })
        }), table]
      });
    } else {
      content = table;
    }
  } else {
    content = /*#__PURE__*/_jsxs(UIFlex, {
      direction: "column",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('emptyState')
      }), /*#__PURE__*/_jsx(FollowupEmailWorkflowButton, {
        contentId: contentId,
        followupEmailId: followupEmailId,
        formGuid: formGuid,
        hasAutomatedEmailEditorAccess: hasAutomatedEmailEditorAccess,
        hasInlineEmailEditorAccess: hasInlineEmailEditorAccess,
        hasWorkflowsAppAccess: hasWorkflowsAppAccess,
        onChangeFollowupEmailEvent: onChangeFollowupEmailEvent,
        onFollowupEmailIdChange: onFollowupEmailIdChange,
        readOnly: readOnly
      })]
    });
  }
  return /*#__PURE__*/_jsx(UIFormControl, {
    "data-field-section": "form-followup-email",
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('label')
    }),
    help: !legacyFollowupEmailId && followupEmailId && /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('helpText')
    }),
    tooltip: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: i18nKey('tooltip_jsx'),
      options: {
        href: 'https://knowledge.hubspot.com/forms/set-up-and-style-forms-on-hubspot-pages#configure-your-form-automation'
      },
      elements: {
        Link: UILink
      }
    }),
    children: content
  });
};
export default connector(FollowupEmail);